import React from "react";
import { FaClipboardCheck, FaDollarSign } from "react-icons/fa";

import { currencyFormat } from "utilities/common";

const CounterManifest = ({ cod, total }) => {
  return (
    <div className="d-flex">
      <div className="d-flex flex-row mb-2 align-items-center pb-3 col-8">
        <div>
          <FaDollarSign size={25} color="#2f83ba" />
        </div>
        <div className="ps-2">
          <div className="fw-bold" style={{ fontSize: 15 }}>
            {currencyFormat(cod?.total_receive || 0)} /{" "}
            <span style={{ fontSize: 10 }}>
              {currencyFormat(cod?.total_cod || 0)}
            </span>
          </div>
          <small>Total COD</small>
        </div>
      </div>
      <div className="d-flex flex-row mb-2 align-items-center pb-3 col-4">
        <div>
          <FaClipboardCheck size={25} color="#2f83ba" />
        </div>
        <div className="ps-2">
          <div className="fw-bold" style={{ fontSize: 15 }}>
            {total}
          </div>
          <small>Total manifest</small>
        </div>
      </div>
    </div>
  )


}

export default CounterManifest;
